import shoppalfoods from "../Assets/Vendors/Shoppal foods/product";
import shoppalgrocery from "../Assets/Vendors/Shoppal groceries/product";
import shoppalpharmacy from "../Assets/Vendors/Shoppal pharmacy/product";
import coldestwater from "../Assets/Vendors/The Coldest Water/product"
import chickenrepublic from "../Assets/Vendors/Chicken Republic/product"
import dominospizza from "../Assets/Vendors/Dominos Pizza/product"
import theplace from "../Assets/Vendors/The Place/product"
import burgerking from "../Assets/Vendors/Burger King/product"
import burgerkinglagos from "../Assets/Vendors/Burger King Lagos/product"
import burgerkingph from "../Assets/Vendors/Burger King PH/product"
import burgerkinguyo from "../Assets/Vendors/Burger King uyo/product"
import chickenrepubliclagos from "../Assets/Vendors/Chicken Republic Uyo/product"
import chickenrepublicph from "../Assets/Vendors/Chicken Republic PH/product"
import chickenrepublicuyo from "../Assets/Vendors/Chicken Republic Uyo main/product"
import dominospizzalagos from "../Assets/Vendors/Dominos Pizza Lagos/product"
import dominospizzaph from "../Assets/Vendors/Dominos Pizza PH/product"
import dominospizzauyo from "../Assets/Vendors/Dominos Pizza Uyo/product"
import theplacelagos from "../Assets/Vendors/The Place Lagos/product"
import theplaceph from "../Assets/Vendors/The Place PH/product"
import theplaceuyo from "../Assets/Vendors/The Place Uyo/product"
import coldestwaterlagos from "../Assets/Vendors/The Coldest Water Lagos/product"
import coldestwaterph from "../Assets/Vendors/The Coldest Water PH/product"
import coldestwateruyo from "../Assets/Vendors/The Coldest Water Uyo/product"

export const productMap = {
  "shoppal-foods":shoppalfoods,
  "shoppal-groceries": shoppalgrocery,
  "shoppal-pharmacy": shoppalpharmacy,
  "coldest-water": coldestwater,
  "chicken-republic": chickenrepublic,
  "dominos-pizza": dominospizza,
  "the-place": theplace,
  "burger-king": burgerking,
  "burger-king-lagos": burgerkinglagos,
  "burger-king-ph": burgerkingph,
  "burger-king-uyo": burgerkinguyo,
  "chicken-republic-lagos": chickenrepubliclagos,
  "chicken-republic-ph": chickenrepublicph,
  "chicken-republic-uyo": chickenrepublicuyo,
  "dominos-pizza-lagos": dominospizzalagos,
  "dominos-pizza-ph": dominospizzaph,
  "dominos-pizza-uyo": dominospizzauyo,
  "the-place-lagos": theplacelagos,
  "the-place-ph": theplaceph,
  "the-place-uyo": theplaceuyo,
  "coldest-water-lagos": coldestwaterlagos,
  "coldest-water-ph": coldestwaterph,
  "coldest-water-uyo": coldestwateruyo,
  
};